import { requestApi } from 'api/Api';

export const listExportJobs = async (navigate, params) => {
  return requestApi({
    navigate,
    method: 'post',
    url: '/api/export/list_jobs',
    params
  });
};

export const createTableExport = async (navigate, params) => {
  return requestApi({
    navigate,
    method: 'post',
    url: '/api/export/table',
    params
  });
};

export const getExportConfig = async (navigate, params) => {
  return requestApi({
    navigate,
    method: 'post',
    url: '/api/export/config',
    params
  });
};
